import React, { Component } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../variables/StripeConfig";
import {
  deploymentEnvironment,
  egeeTouchPlans,
  customLog,
} from "../../variables/Variables";
import CustomPlanBtn from "./CustomPlanBtn";
import LocalizedStrings from "react-localization";
import { fire, auth } from "../../firebase/index";
import "../../assets/css/maincss.css";
import { result } from "lodash";
import { Link } from "react-router-dom";
import { validationMessage } from "./RedemptionHelper";
import { isWindows } from "react-device-detect";

const REDEEMED_CODE_ERR_MSG = 1;
const INVALID_CODE_ERR_MSG = 2;
const SUCCESS_CODE_MSG = 3;
const EMPTY_CODE_ERR_MSG = 4;
const DEFAULT_CODE_MSG = 0; // Empty field , initial state

let localizationStrings = new LocalizedStrings({
  en: {
    subscriptionTitle: "Subscription",
    selectTitle: "- Please Select Your lock Type -",
    enterBtn: "Enter",
    enterPromoCode: "Enter your promo code",
    redeemedCodeError: "This code has already been redeemed",
    invalidCodeErr: "Invalid code. Please try again",
    emptyFieldError: "Please enter your promo code",
  },
  ja: {
    subscriptionTitle: "サブスクリプション",
    selectTitle: "ロックを選択してください",
    enterBtn: "OK",
    enterPromoCode: "コードを入力して下さい。",
    redeemedCodeError: "入力されたコードはすでに使用済です。",
    invalidCodeErr: "コードエラー。再度入力して下さい。",
    emptyFieldError: "コードを入力して下さい。",
  },
  es: {
    subscriptionTitle: "Suscripción",
    selectTitle: "- Por favor selecciona tu tipo de candado -",
    enterBtn: "Ingresar",
    enterPromoCode: "Ingresa tu código promocional",
    redeemedCodeError: "Este código ya ha sido canjeado",
    invalidCodeErr: "Código inválido. Por favor, intenta de nuevo",
    emptyFieldError: "Por favor, ingresa tu código promocional",
  },
});

const planTitleStyle = {
  marginTop: "50px",
  marginBottom: "50px",
  textAlign: "center",
};

export default class CustomPlanPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      existingAccount: false,
      inputCustomCode: "",
      existingSuperAdminStatus: false,
      validationMessage: "",
    };

    this.toInputUppercase = this.toInputUppercase.bind(this);
    this.handleInputCode = this.handleInputCode.bind(this);
    this.validateCustomCode = this.validateCustomCode.bind(this);
    this.handleValidationMessage = this.handleValidationMessage.bind(this);
    this.handleInputCSS = this.handleInputCSS.bind(this);
    this.handleButtonCSS = this.handleButtonCSS.bind(this);

    this.textInputCode = React.createRef();
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  handleInputCode(code) {
    this.setState({
      inputCustomCode: code.target.value,
    });
  }

  validateCustomCode(e) {
    e.preventDefault();

    // default validationMessage = 0
    this.setState({
      validationMessage: DEFAULT_CODE_MSG,
    });

    const inputCode = this.state.inputCustomCode;

    var BreakException = {};

    if (inputCode === "") {
      this.setState({
        validationMessage: EMPTY_CODE_ERR_MSG,
      });
    } else {
      try {
        fire
          .database()
          .ref("CustomPlanSubscriptions/" + inputCode)
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists() && snapshot.val().isClaimed === false) {
              //Re-assign the values from firebase for the egeeTouchplan4 from "../../variables/Variables"
              egeeTouchPlans.egeeTouchplan4.maxAcc = snapshot.val().maxUsers;
              egeeTouchPlans.egeeTouchplan4.maxLocks = snapshot.val().maxLocks;
              egeeTouchPlans.egeeTouchplan4.maxMulti = snapshot.val().maxMulti;
              egeeTouchPlans.egeeTouchplan4.maxTags = snapshot.val().maxTags;
              egeeTouchPlans.egeeTouchplan4.planPrice = snapshot.val().planPrice;
              egeeTouchPlans.egeeTouchplan4.originalDisplayPrice = snapshot.val().originalPrice;
              egeeTouchPlans.egeeTouchplan4.discountedDisplayPrice = snapshot.val().discountPrice;
              egeeTouchPlans.egeeTouchplan4.discountDisplay = snapshot.val().discount;
              egeeTouchPlans.egeeTouchplan4.planDurationDisplay = snapshot.val().planDuration;
              egeeTouchPlans.egeeTouchplan4.planName = snapshot.val().planName;
              egeeTouchPlans.egeeTouchplan4.planNumber = snapshot.val().plan;
              egeeTouchPlans.egeeTouchplan4.testId = snapshot.val().testId;
              egeeTouchPlans.egeeTouchplan4.trial_period_days = snapshot.val().trial_period_days;
              egeeTouchPlans.egeeTouchplan4.customCode = snapshot.key;

              //if deploymentEnviroment = false , push the stripe testing plan id
              //if deploymentEnviroment = live, push the live stripe plan id
              if (deploymentEnvironment) {
                egeeTouchPlans.egeeTouchplan4.planId = snapshot.val().planId_live;
              } else {
                egeeTouchPlans.egeeTouchplan4.planId = snapshot.val().planId_test;
              }

              this.setState({
                validationMessage: SUCCESS_CODE_MSG,
              });
            } else if (
              snapshot.exists() &&
              snapshot.val().isClaimed !== false
            ) {
              this.setState({
                validationMessage: REDEEMED_CODE_ERR_MSG,
              });
            } else if (!snapshot.exists()) {
              this.setState({
                validationMessage: INVALID_CODE_ERR_MSG,
              });
            }
          });
      } catch (e) {
        if (e !== BreakException) {
          throw e;
        }
      }
    }
  }
  handleValidationMessage(msg) {
    if (msg === REDEEMED_CODE_ERR_MSG) {
      return localizationStrings.redeemedCodeError;
    } else if (msg === INVALID_CODE_ERR_MSG) {
      return localizationStrings.invalidCodeErr;
    } else if (msg === EMPTY_CODE_ERR_MSG) {
      return localizationStrings.emptyFieldError;
    } else if (msg === SUCCESS_CODE_MSG) {
      return "";
    }
  }
  handleInputCSS(msg) {
    if (
      msg === REDEEMED_CODE_ERR_MSG ||
      msg === INVALID_CODE_ERR_MSG ||
      msg === EMPTY_CODE_ERR_MSG
    ) {
      return "customCodeInputErr";
    } else if (msg === SUCCESS_CODE_MSG) {
      return "customCodeInput";
    } else {
      return "customCodeInput";
    }
  }
  handleButtonCSS(msg) {
    if (
      msg === REDEEMED_CODE_ERR_MSG ||
      msg === INVALID_CODE_ERR_MSG ||
      msg === EMPTY_CODE_ERR_MSG
    ) {
      return "customButtonErr";
    } else if (msg === SUCCESS_CODE_MSG) {
      return "customButton";
    } else {
      return "customButton";
    }
  }

  // componentDidMount() {
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    customLog(deploymentEnvironment ? "Live Environment @ Plans" : "Test Environment @ Plans");

    return (
      <Elements stripe={stripePromise}>
        <div>
          <h1 id="egeeTouchPlans" style={planTitleStyle}>
            eGeeTouch {localizationStrings.subscriptionTitle} Plan
          </h1>
          <form className="alignCustomForm">
            <div className="flex">
              <input
                className={
                  this.state.validationMessage
                    ? this.handleInputCSS(this.state.validationMessage)
                    : "customCodeInput"
                }
                name={this.textInputCode}
                ref={this.textInputCode}
                onChange={(e) => this.handleInputCode(e, this.textInputCode)}
                maxLength="12"
                onInput={this.toInputUppercase}
                placeholder={localizationStrings.enterPromoCode}
              />
              <button
                className={
                  this.state.validationMessage
                    ? this.handleButtonCSS(this.state.validationMessage)
                    : "customButton"
                }
                onClick={this.validateCustomCode}
              >
                {localizationStrings.enterBtn}
                {/* Enter */}
              </button>
            </div>
          </form>
          {this.state.validationMessage === SUCCESS_CODE_MSG ? (
            <div>
              <p>
                {this.handleValidationMessage(this.state.validationMessage)}
              </p>

              <CustomPlanBtn customPlanProp={"welcome"} />
            </div>
          ) : (
            <p
              style={{
                color: "red",
                textAlign: "center",
                marginTop: "20px",
                fontSize: "22.5px",
              }}
            >
              {this.handleValidationMessage(this.state.validationMessage)}
            </p>
          )}
        </div>
      </Elements>
    );
  }
}
